import CoreComponent from '../../core/CoreComponent.vue';
import Swiper from 'swiper';
import { Pagination, Keyboard, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
export default {
  extends: CoreComponent,
  mounted() {
    const bulletButtonAriaLabel = window.Granite?.I18n?.get('cardcontainer.carousel.pagination');
    const contentPanel = this.cmpEl.querySelector('.cmp-contentpanelcontainer__card-image__carousel');
    if (contentPanel) {
      // Add click event to each image
      const cardImages = this.cmpEl.querySelectorAll('.card-image');
      cardImages.forEach(image => {
        const card = image.closest('.cmp-contentpanelcontainer__card');
        const ctaElement = card?.querySelector('.cmp-button');
        if (ctaElement) {
          image.style.cursor = 'pointer';
          image.addEventListener('click', () => {
            ctaElement.click();
          });
        }
      });
      var panelSwiper = new Swiper(contentPanel, {
        slidesPerView: 1,
        watchSlidesProgress: true,
        modules: [Keyboard, Pagination, Navigation],
        keyboard: {
          enabled: true,
          onlyInViewport: true
        },
        pagination: {
          el: this.cmpEl.querySelector('.cmp-contentpanelcontainer--carousel-pagination'),
          clickable: true,
          bulletElement: 'button',
          renderBullet: function () {
            return `<button class="dot swiper-pagination-bullet" aria-label="${bulletButtonAriaLabel}"><span class="invisible">${bulletButtonAriaLabel}</span></button>`;
          }
        },
        navigation: {
          nextEl: null,
          prevEl: null
        }
      });
      const paginationContainers = this.cmpEl.querySelectorAll('.cmp-contentpanelcontainer--carousel-pagination');
      paginationContainers.forEach(paginationContainer => {
        const paginationBullets = paginationContainer.querySelectorAll('.swiper-pagination-bullet');
        const bulletCount = paginationBullets.length;
        const nextButton = document.createElement('div');
        nextButton.classList.add('swiper-button-next');
        const prevButton = document.createElement('div');
        prevButton.classList.add('swiper-button-prev');

        //check if closet parent swiper-button-prev is there
        var swiperInitializedElement = "";
        var prevButtonElement = "";
        var nextButtonElement = "";
        if (bulletCount >= 2) {
          prevButton.style.display = 'flex';
          nextButton.style.display = 'flex';
          const carouselContainer = paginationContainer.closest('.cmp-contentpanelcontainer--carousel');
          const swiperWrapper = carouselContainer.querySelector('.swiper-wrapper');
          swiperInitializedElement = swiperWrapper.querySelector('.swiper-initialized');
          prevButtonElement = swiperInitializedElement.querySelector('.swiper-button-prev');
          nextButtonElement = swiperInitializedElement.querySelector('.swiper-button-next');
          if (prevButtonElement == null && nextButtonElement == null) {
            paginationContainer.appendChild(prevButton);
            paginationContainer.appendChild(nextButton);
            panelSwiper.params.navigation.prevEl = prevButton;
            panelSwiper.params.navigation.nextEl = nextButton;
            panelSwiper.navigation.init();
            panelSwiper.navigation.update();
          }
        }
      });
    }
  }
};